import {
  Flex,
  Select,
  Text,
  type FlexProps,
  type SelectProps,
} from '@mantine/core';
import baseClasses from './FormSelect.module.scss';
import type { Variant } from './FormSelect.type';

interface FormSelectProps extends Omit<SelectProps, 'variant'> {
  title: string;
  description: string;
  containerProps?: FlexProps;
  variant?: Variant;
}

export const FormSelect = ({
  title,
  description,
  containerProps,
  variant = 'row',
  ...props
}: FormSelectProps) => {
  const styles = {
    form: variant === 'row' ? baseClasses.formRow : baseClasses.formColumn,
    leftColumn: variant === 'row' ? baseClasses.leftColumn : '',
    rightColumn:
      variant === 'row' ? baseClasses.rightColumn : baseClasses.input,
  };

  return (
    <Flex gap='24' className={styles.form} {...containerProps}>
      <Flex direction='column' gap={6} className={styles.leftColumn}>
        <Text className={baseClasses.title}>{title}</Text>
        <Text className={baseClasses.description}>{description}</Text>
      </Flex>

      <Select className={styles.rightColumn} variant='filled' {...props} />
    </Flex>
  );
};
